import { FileImageOutlined } from '@ant-design/icons';
import { isGranted, L } from '@lib';
import { Modal, Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import type { UploadFile } from 'antd/es/upload/interface';
import { RcFile } from 'antd/lib/upload';
import React from 'react';
import './MyLogo.css';
interface IProps {
  disabled?: boolean;
  fileList: UploadFile[];
  showDeleteModal: boolean;
  enableCrop?: boolean;
  handleRemove: () => void;
  handleUpload: (file: RcFile) => void;
  onPreview: (file: UploadFile) => void;
  beforeCrop: (file: File) => boolean;
  setShowDeleteModal: (value: boolean) => void;
}

const MyLogo: React.FC<IProps> = ({
  disabled = false,
  fileList,
  showDeleteModal,
  enableCrop = true,
  handleRemove,
  handleUpload,
  onPreview,
  beforeCrop,
  setShowDeleteModal,
}) => {
  const noImgContent =
    (isGranted('Pages.Tenants') && <FileImageOutlined style={{ fontSize: '600%' }} />) ||
    `+ ${L('Upload')}`;

  const uploadComponent = (
    <Upload
      listType="picture-card"
      accept="image/png, image/jpeg"
      fileList={fileList}
      disabled={disabled}
      onPreview={onPreview}
      onRemove={() => setShowDeleteModal(true)}
      customRequest={(e) => handleUpload(e.file as RcFile)}
      className="customCol"
    >
      {!fileList.length && noImgContent}
    </Upload>
  );

  return (
    <>
      {enableCrop ? (
        <ImgCrop aspect={16 / 9} beforeCrop={beforeCrop} rotationSlider>
          {uploadComponent}
        </ImgCrop>
      ) : (
        uploadComponent
      )}
      <Modal
        title={L('Are you sure you want to remove the image?')}
        open={showDeleteModal}
        onCancel={() => setShowDeleteModal(false)}
        okText={L('Confirm')}
        onOk={handleRemove}
      />
    </>
  );
};

export default MyLogo;
